import { render, staticRenderFns } from "./NewSession.vue?vue&type=template&id=2db60fb9&"
import script from "./NewSession.vue?vue&type=script&lang=ts&"
export * from "./NewSession.vue?vue&type=script&lang=ts&"
import style0 from "./NewSession.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports